/* eslint-disable @typescript-eslint/no-unused-vars */
import { mdiChevronDown } from '@mdi/js';
import Icon from '@mdi/react';
import { forwardRef, useContext } from 'react';

import { FormControlContext } from '@/components/FormControl';
import * as styles from '@/styles/components/Select';

type Select = {
  width?: string;
  height?: string;
  sizeIcon?: string;
  options: {
    value: string | number;
    label: string;
  }[];
  background?: string;
  border?: string;
  isWidth?: boolean;
  keysDisabled?: (string | number)[];
} & JSX.IntrinsicElements['select'];

const Select = forwardRef<HTMLSelectElement, Select>(function Select(
  {
    value,
    width = '',
    height = '4.8rem',
    sizeIcon = '2.4rem',
    disabled,
    options = [],
    background,
    border,
    isWidth = false,
    keysDisabled,
    ...props
  }: Select,
  ref,
) {
  const { invalid } = useContext(FormControlContext);

  return (
    <div css={styles.root(width, isWidth, border)} aria-disabled={disabled} aria-invalid={invalid} data-testid='select'>
      <select css={styles.select(background, height)} ref={ref} {...props} disabled={disabled} value={value}>
        {options.map((option, i) => {
          return (
            <option value={option.value} key={i} disabled={keysDisabled?.includes(option.value)}>
              {option.label}
            </option>
          );
        })}
      </select>
      <span css={styles.icon}>
        <Icon path={mdiChevronDown} title='' size={sizeIcon} />
      </span>
    </div>
  );
});

export default Select;
